import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const faqs = [
  {
    question: "What is NRI Local Buddy?",
    answer:
      "NRI Local Buddy is your trusted partner in India, offering personalized services for NRI families — including property care, parental support, and travel assistance."
  },
  {
    question: "How does property care work?",
    answer:
      "Our property care team ensures your property is safe, well-maintained, and regularly inspected. We provide updates with photos, manage rentals, and handle repairs or upkeep as needed."
  },
  {
    question: "Do you provide support for elderly parents?",
    answer:
      "Yes. Our parental care services include regular check-ins, assistance with medical appointments, emergency coordination, and emotional companionship for your loved ones."
  },
  {
    question: "Can you assist with airport pickups or travel planning?",
    answer:
      "Absolutely! We can coordinate airport transfers, arrange drivers, book accommodations, and plan itineraries for your visits or your family’s travel needs."
  },
  {
    question: "Is the service available across all cities in India?",
    answer:
      "We currently operate in major metros and tier-1 cities. However, we’re expanding rapidly, and custom arrangements can be made for other locations on request."
  },
  {
    question: "How can I get started?",
    answer:
      "Simply sign up on our website or contact us via WhatsApp or email. Our local buddy will reach out to understand your needs and customize a plan for you."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2
          className="text-3xl font-bold text-center text-gray-800 mb-10"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Frequently Asked Questions
        </motion.h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-2xl shadow-sm border border-gray-200 p-5"
              whileHover={{ scale: 1.01 }}
              transition={{ duration: 0.2 }}
            >
              <button
                className="w-full flex justify-between items-center text-left"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-lg font-medium text-gray-800">
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <FiChevronUp className="text-blue-600 text-xl" />
                ) : (
                  <FiChevronDown className="text-blue-600 text-xl" />
                )}
              </button>

              <AnimatePresence initial={false}>
                {openIndex === index && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                    className="mt-3 text-gray-600 leading-relaxed"
                  >
                    {faq.answer}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
